module.exports = __webpack_public_path__ + "static/media/pay-visa.8834af73.png";